import { Button } from '@myua/kit';
import { View3D } from '../../icons/View3D';
import { FC } from 'react';
import '../style.scss';

export const View3DButton: FC<{ onClick: () => void; className?: string }> = ({
  onClick,
  className,
}) => {
  return (
    <Button onClick={onClick} className={`al-view-3d-button ${className ?? ''}`}>
      <View3D /> 3D VIEW
    </Button>
  );
};
